import React, { useState, useEffect } from "react";
import "../styles/allevents.css";
import "../styles/data.css";
import Header from '../../repeat/Header'
import Footer from '../../repeat/Footer'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
const Allevents = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    // Fetch data from your PHP API endpoint
    fetch("https://gptkpm.in/backend/events/code/alltabledata.php")
      .then((response) => response.json())
      .then((data) => setEvents(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleImageClick = (event) => {
    setSelectedEvent(event);
  };

  const closePopup = () => {
    setSelectedEvent(null);
  };

  return (
    <div className="allevents-container">
      {/* <Header/> */}
      <h1>All Events</h1>
      <div className="image-grid">
        {events.map((event, index) => (
          <div key={index} className="grid-item" onClick={() => handleImageClick(event)}>
            <img src={`data:image/jpeg;base64,${event.images}`} alt={event.title} />
          </div>
        ))}
      </div>
      

      {selectedEvent && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-image">
              <img
                src={`data:image/jpeg;base64,${selectedEvent.images}`}
                alt={selectedEvent.title}
              />
            </div>
            <div className="popup-details">
              <h2>{selectedEvent.title}</h2>
              <p><strong>Description:</strong> {selectedEvent.description}</p>
              <p><strong>Department:</strong> {selectedEvent.department}</p>
              <p><strong>Date:</strong> {selectedEvent.date}</p>
            </div>
            <button className="close-button" onClick={closePopup}>
            <FontAwesomeIcon icon={faClose} />
            </button>
          </div>
        </div>
      )}
      {/* <Footer/> */}
    </div>
  );
};

export default Allevents;